const shuffle = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

class RelatedArticles extends HTMLElement {
  constructor() {
    super();
    this.sourceUrl = this.querySelector("[data-source] a").href;
    this.container = this.querySelector("[data-container]");
    this.exclude = this.getAttribute("exclude");

    fetch(`${this.sourceUrl}?view=related`)
      .then((response) => response.text())
      .then((response) => {
        const doc = new DOMParser().parseFromString(response, "text/html");

        const cards = shuffle(
          [...doc.querySelectorAll("[data-card]")].filter(
            (card) => card.dataset.card !== this.exclude
          )
        ).slice(0, 3);

        if (!cards.length) {
          this.style.display = "none";
        }

        this.container.append(...cards);

        return window.loadSwiper;
      })
      .then(({ Swiper }) => {
        this.Swiper = Swiper;
        window.addEventListener("resize", () => this._checkCarousel());
        this._checkCarousel();
      });
  }

  _checkCarousel() {
    if (window.matchMedia("(max-width: 1024px)").matches) {
      this._initCarousel();
    } else {
      this._destroyCarousel();
    }
  }

  _initCarousel() {
    if (this.swiper) return;

    this._toggleSwiperClasses(true);

    const swiperParams = {
      slidesPerView: "auto",
      speed: 400,
      spaceBetween: 8,
    };

    this.swiper = new this.Swiper(this.querySelector(".swiper"), swiperParams);
  }

  _destroyCarousel() {
    if (!this.swiper) return;

    this.swiper.destroy(true, true);
    this.swiper = null;
    this._toggleSwiperClasses(false);
  }

  _toggleSwiperClasses(add) {
    this.querySelectorAll("[data-swiper-class]").forEach((el) => {
      el.classList.toggle(el.dataset.swiperClass, add);
    });
  }
}

if (!customElements.get("related-articles")) {
  customElements.define("related-articles", RelatedArticles);
}
